import React from "react";
import { arrayOf, func, number, oneOfType, shape, string } from "prop-types";

import { formatMoney } from "src/shared/utilities/formatMoney";

import ImageBox from "../ImageBox";
import LicenseInfo from "../LicenseInfo";
import ListingInfo from "../ListingInfo";
import * as S from "./styled";

const ListingCardHorizontal = ({
  area,
  bathrooms,
  bedrooms,
  className,
  contacts,
  imgSrc,
  onCardClick,
  price,
  title,
  url
}) => (
  <S.CardContainer className={className} contacts={contacts}>
    <S.LinkToProperty href={url} onClick={onCardClick} target="_blank">
      {title}
    </S.LinkToProperty>
    <ImageBox imgSrc={imgSrc} theme="horizontalCard" />
    <S.InfoBox>
      <S.AreaInfo>{area}</S.AreaInfo>
      <S.Title>{title}</S.Title>
      <S.Price>{formatMoney(price)}</S.Price>
      <ListingInfo bath={bathrooms} beds={bedrooms} />
    </S.InfoBox>
    {contacts.length > 0 && (
      <S.BottomBox>
        <LicenseInfo contacts={contacts} />
      </S.BottomBox>
    )}
  </S.CardContainer>
);

ListingCardHorizontal.defaultProps = {
  className: "",
  contacts: [],
  onCardClick: () => {}
};

ListingCardHorizontal.propTypes = {
  area: string.isRequired,
  bathrooms: oneOfType([number, string]).isRequired,
  bedrooms: oneOfType([number, string]).isRequired,
  className: string,
  contacts: arrayOf(
    shape({
      id: string,
      business_url: string,
      business_name: string,
      full_business_address: string
    })
  ),
  imgSrc: string.isRequired,
  onCardClick: func,
  price: number.isRequired,
  title: string.isRequired,
  url: string.isRequired
};

export default ListingCardHorizontal;
